function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1.4053254,0,0,1.4053254,-1.0133136,-1.0133136)"
}, React.createElement("path", {
  d: "M 36.3,2.5 C 17.6,2.5 2.5,17.7 2.5,36.3 2.5,55 17.7,70.1 36.3,70.1 55,70.1 70.1,54.9 70.1,36.3 70.1,17.6 55,2.5 36.3,2.5 Z M 48.9,31.1 34.7,45.3 C 34.3,45.8 33.6,46 33,46 32.4,46 31.7,45.7 31.3,45.3 l -7.6,-7.6 c -0.9,-0.9 -0.9,-2.5 0,-3.4 0.9,-0.9 2.5,-0.9 3.4,0 L 33,40.2 45.5,27.7 c 0.9,-0.9 2.5,-0.9 3.4,0 0.9,0.9 0.9,2.5 0,3.4 z"
}));

var SvgDone = function SvgDone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done.eeeb85e2.svg";
export { ForwardRef as ReactComponent };